import { createFileRoute } from "@tanstack/react-router";
import ProductHubList from "@/pages/ProductHubList";

export const Route = createFileRoute("/lawn-mowers/reviews")({
  component: () => <ProductHubList hubSlug="lawn-mowers" variant="reviews" />,
});
